export const OPENENV_DEV = "https://dev.envestnet.io/openenv/api/ciam/ext";
export const OPENENV_QA = "https://qa.envestnet.io/openenv/api/ciam/ext";
export const OPENENV_UAT = "https://uat.envestnet.io/openenv/api/ciam/ext";
export const OPENENV_REGQA = "http://trvregqa01";
export const OPENENV_QL = "https://ql-api.envestnet.com";
export const OPENENV_PROD = "https://api.envestnet.com";

export const MAGNUM_DEV =
  "http://microservice.dev-env.us-south-01.envestnet.cloud:10009";
export const MAGNUM_UAT = "https://uat-api.envestnet.com";
export const MAGNUM_QA =
  "http://microservice.qa-env.us-south-01.envestnet.cloud:10009";
export const MAGNUM_QL =
  "http://microservice.ql-env.us-north-01.envestnet.cloud:10009";
export const MAGNUM_PROD = "https://api.envestnet.com";

export const getOpenenvHost = (hostname) => {
  if (window.config?.API_URL) {
    return window.config?.API_URL;
  }

  switch (hostname) {
    case "access.envestnet.com":
    case "admin.envestnet.com":
    case "advisor.envestnet.com":
    case "advisorchannel.envestnet.com":
    case "aegon.envestnet.com":
    case "ag.envestnet.com":
    case "ameriprise.envestnet.com":
    case "atlantic.envestnet.com":
    case "barclays.envestnet.com":
    case "batch.envestnet.com":
    case "cma-sec.envestnet.com":
    case "cma-sec1.envestnet.com":
    case "cma-trust.envestnet.com":
    case "comerica.envestnet.com":
    case "eservice.envestnet.com":
    case "harrisbank.envestnet.com":
    case "hrblock.envestnet.com":
    case "inst.envestnet.com":
    case "kestrafinancial.envestnet.com":
    case "kis.envestnet.com":
    case "loringward.envestnet.com":
    case "man.envestnet.com":
    case "manager.envestnet.com":
    case "nfp.envestnet.com":
    case "oberon.envestnet.com":
    case "ops.envestnet.com":
    case "portal.envestnet.com":
    case "reporting.envestnet.com":
    case "saa.envestnet.com":
    case "scotia.envestnet.com":
    case "seiadvisorreporting.com":
    case "seiclientreporting.com":
    case "streetscape.envestnet.com":
    case "symmetrypartners.envestnet.com":
    case "tdpcw.envestnet.com":
    case "ubs.envestnet.com":
    case "wealth.envestnet.com":
    case "tiaa-cref.envestnet.com":
      return OPENENV_PROD;

    case "ql.envestnet.com":
      return OPENENV_QL;

    case "uat.envestnet.com":
    case "uatadmin.envestnet.com":
    case "uatbatch.envestnet.com":
      return OPENENV_UAT;

    case "trvregqa01":
      return OPENENV_REGQA;

    case "ump.qa-env.us-south-01.envestnet.cloud":
      return OPENENV_QA;

    case "ump.dev-env.us-south-01.envestnet.cloud":
      return OPENENV_DEV;

    case "localhost":
      // #!if ENV === 'development'
      return process.env.API_URL || OPENENV_DEV;
      // #!else
      // eslint-disable-next-line
      return OPENENV_DEV; // NOSONAR
    // #!endif

    default:
      return "";
  }
};

export const getMagnumHost = (openenvUrl) => {
  switch (openenvUrl) {
    case OPENENV_PROD:
      return MAGNUM_PROD;

    case OPENENV_QL:
      return MAGNUM_QL;

    case OPENENV_UAT:
      return MAGNUM_UAT;

    case OPENENV_QA:
    case OPENENV_REGQA:
      return MAGNUM_QA;

    case OPENENV_DEV:
      return MAGNUM_DEV;

    default:
      return "";
  }
};

const getAPIUrl = (hostname) => {
  const openenvHost = getOpenenvHost(hostname);
  const magnumHost = getMagnumHost(openenvHost);
  return {
    openenvUrl: `${openenvHost}/openenv/api`,
    magnumUrl: `${magnumHost}/magnum/api`,
  };
};

export default getAPIUrl;
